import { WeeklyScheduleClient } from '../services/ohl.virtualCenter.api';

const apiWeeklyScheduleClient = new WeeklyScheduleClient(process.env.REACT_APP_PUBLIC_API);

class WeeklyScheduleProvider {

    getList = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        
        if(params.filter && params.filter.q) params.filter.id = params.filter.q;

        return apiWeeklyScheduleClient.list({
            pageNumber: page,
            pageSize: perPage,
            orderField: field,
            orderAsc: order === 'ASC',
            ...params.filter
        }).then((data) => {
            data.elements = data.elements.map(
                e => ({
                    ...e,
                })
            )
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }


    updateOrCreate = (resource, params) => {
        return apiWeeklyScheduleClient.weeklySchedule(params).then((data) => ({
            data
        }));
    }

};

export default new WeeklyScheduleProvider();